<template src="../templates/normal_fcont_71.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
export default {
  name: 'app',
  data() {
    return {
      articleId: '71',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,CreativePrint,ReleaseDateForArticle,AppDownloadCreative
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['71-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['71-2']}
    ]};
  }
};
</script>
<style />


